export default function buildTableFilterQueryOpts(paginationQuery) {
  // sample URL with filter criteria:
  // http://localhost:9000/api/license-data?customer.contains=gem&portalUrl.equals=http
  if (paginationQuery) {
    let filters = '';
    console.log('paginationQuery: ', paginationQuery.criteria);

    paginationQuery.criteria.forEach((value: string, key: string) => {
      if (filters.length > 0) {
        filters += '&';
      }
      filters += key + '=' + paginationQuery.criteria.get(key);
    });
    return `${filters}`;
  }
  return '';
}
